var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHorizontalLine = function SvgHorizontalLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 3,
    fill: "none",
    viewBox: "0 0 15 2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    d: "M0 1h15"
  })));
};
export { SvgHorizontalLine as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMyIgdmlld0JveD0iMCAwIDE1IDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wIDFIMTUiIHN0cm9rZT0iIzRENEQ0RCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9zdmc+";